import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Code128Service } from './code128.service';

@Directive({
  selector: '[appBarcode]',
})
export class NewBarcodeDirective implements OnChanges {
  @Input() appBarcode: string = '';
  @Input() barcodeWidth: number = 2;
  @Input() barcodeHeight: number = 100;
  @Input() barcodeDisplayValue: boolean = true;

  constructor(
    private el: ElementRef,
    private code128Service: Code128Service
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appBarcode']) {
      this.generateBarcode();
    }
  }

  private generateBarcode(): void {
    if (!this.appBarcode) return;

    try {
      const svg = this.code128Service.toSVG(this.appBarcode, {
        width: this.barcodeWidth,
        height: this.barcodeHeight,
        displayValue: this.barcodeDisplayValue
      });
      
      this.el.nativeElement.innerHTML = svg;
    } catch (error) {
      console.error('Erreur génération code-barres:', error);
    }
  }
}
